<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <loading-spinner v-if="loading" />

    <template v-else-if="item.id">
      <div class="row justify-content-between px-3 mb-4">
        <img
          src="../assets/images/logo-comune.png"
          style="height:80px"
        >
      </div>
      <h2 class="text-center mt-4 text-uppercase">
        PROSPETTO REDDITI E PATRIMONIO
      </h2>

      <h4 class="text-center text-primary mt-3 mb-5 font-weight-bold text-uppercase">
        <span v-if="isOpen">
          Comunicazione da confermare
        </span>
      </h4>

      <!-- Inserire dati utente intestatario. Come testata della pagina -->

      <p class="text-center font-weight-bold my-3 text-uppercase">
        PROSPETTO A – REDDITI:
      </p>
      <b-form inline>
        <p class="text-justify px-4">
          <span>Dichiarazione fiscale anno</span>
          <b-input
            :disabled="!isOpen"
            class="form-field"
            v-model.trim="item.anno"
            type="number"
            :min="new Date().getFullYear() - 1"
            :max="new Date().getFullYear()"
            trim
            style="width:5rem"
            placeholder="anno"
            :state="fieldState('anno')"
            @change="modificaFamiliare"
          />
          <b-form-invalid-feedback v-if="!$v.redditiPatrimonio.anno.required">Campo obbligatorio</b-form-invalid-feedback>
          <!-- <span class="form-field">{{ item.anno }}</span> -->
          <span>riferita ai redditi percepiti nell’anno</span>
          <b-input
            :disabled="!isOpen"
            class="form-field"
            v-model.trim="item.annoFiscale"
            type="number"
            :min="new Date().getFullYear() - 2"
            :max="new Date().getFullYear() - 1"
            trim
            style="width:5rem"
            placeholder="anno fiscale"
            :state="fieldState('anno')"
            @change="modificaFamiliare"
          />
          <b-form-invalid-feedback v-if="!$v.redditiPatrimonio.annoFiscale.required">Campo obbligatorio</b-form-invalid-feedback>
          <!-- <span class="form-field">{{ item.annoFiscale }}</span> -->
        </p>
      </b-form>

      <!-- Inserire tabella REDDITI -->
      <div class="ml-4 mb-3">
        <redditi-patrimonio-table
          :item="item"
          @aggiornaFamiglia="modificaFamiliare"
        />
      </div>

      <p class="text-center font-weight-bold my-3 text-uppercase">
        PROSPETTO B – PATRIMONIO IMMOBILIARE
      </p>

      <!-- Inserire tabella PATRIMONIO IMMOBILIARE -->
      <div class="ml-4 mb-3">
        <immobili-patrimonio-table
          :item="item"
          @aggiornaFamiglia="modificaFamiliare"
        />
      </div>

      <p class="small font-italic text-justify mx-4 mb-2">
        <span>I dati acquisiti saranno utilizzati in conformità al nuovo Regolamento Generale sulla Protezione dei Dati Personali (GDPR). Per maggiori dettagli, si prega di consultare la pagina internet: </span>
        <a
          href="https://www.aequaroma.it/societa/privacy-policy.html"
          target="_blank"
        >
          https://www.aequaroma.it/societa/privacy-policy.html
        </a>.
      </p>

      <p
        v-if="item.dataConferma"
        class="text-left mt-5"
      >
        Roma,<span class="form-field">
          {{ moment(item.dataConferma).format('DD/MM/YYYY') }}
        </span>
      </p>

      <div class="row mt-4 mx-2">

        <!-- <b-button
          v-if="isOpen"
          variant="success"
          class="m-2"
          @click="doSaveConfirm"
        >
          <font-awesome-icon
            icon="check"
            class="text-white mr-2"
          />Salva e conferma
        </b-button> -->

        <b-button
          v-if="isOpen"
          variant="primary"
          class="m-2"
          @click="doSaveDraft"
        >
          <font-awesome-icon
            icon="save"
            class="text-white mr-2"
          />Salva in bozza
        </b-button>

        <b-button
          v-if="isOpen && item.stato === 'B'"
          variant="danger"
          class="m-2"
          @click="doDeleteDraftConfirm"
        >
          <font-awesome-icon
            icon="trash-alt"
            class="text-white mr-2"
          />Elimina bozza
        </b-button>

        <a
          v-if="!isOpen && item.stato !== 'P'"
          target="_blank"
          :href="urlIstanza"
        >
          <button class="btn btn-success m-2">
            <font-awesome-icon
              icon="download"
              class="text-white mr-2"
            />Scarica documento
          </button>
        </a>

        <b-button
          variant="outline-secondary"
          class="m-2"
          @click="back"
        >
          <font-awesome-icon
            icon="times"
            class="mr-2"
          />Chiudi
        </b-button>

      </div>
    </template>

    <b-modal
      ref="confirmModal"
      title="Conferma operazione"
      :centered="true"
      no-close-on-backdrop
      ok-title="Conferma"
      ok-variant="success"
      cancel-title="Annulla"
      cancel-variant="outline-secondary"
    >
      ... testo conferma salvataggio...
    </b-modal>

  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import numeral from 'numeral'
import LoadingSpinner from '@/components/LoadingSpinner'
import ImmobiliPatrimonioTable from '@/components/ImmobiliPatrimonioTable'
import redditiPatrimonioTable from '@/components/RedditiPatrimonioTable'
// import FamiliariTable from '@/components/FamiliariTable'

export default {
  components: {
    LoadingSpinner,
    // FamiliariTable,
    ImmobiliPatrimonioTable,
    redditiPatrimonioTable
  },

  data () {
    return {
      loading: true,
      item: {},
      fileAllegati: {},
      message: '',
      isModificato: false
    }
  },

  validations: {
    redditiPatrimonio: {
      anno: { required },
      annoFiscale: { required }
    }
  },

  watch: {
    'item.nuoviFamiliari' (newVal) {
      this.item.numeroComponenti = newVal ? newVal.length : 0
    }
  },

  computed: {
    moment () {
      return moment
    },
    numeral () {
      return numeral
    },
    isOpen () {
      return !(this.item.stato === 'V')
    },
    urlIstanza () {
      return `/api/istanze/${this.item.id}/download`
    }
  },

  async created () {
    await this.load()
  },

  methods: {
    back () {
      // this.$router.push({ name: 'istanze' })
      this.$router.go(-1)
    },

    async load () {
      try {
        this.loading = true
        let id = this.$route.params.id
        await this.$store.dispatch('redditiPatrimonio/loadItemById', id)
        let item = this.$store.state.redditiPatrimonio.item
        this.item = item
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },
    doSaveConfirm () {
      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: 'Una volta salvato, il documento non potrà più essere modificato. Confermi il salvataggio del documento?',
        // okHandler: this.doSaveDraft
        okHandler: this.doSave
      })
    },

    async doSave () {
      try {
        this.loading = true
        this.item.stato = 'V'

        // Salvataggio dei file allegati.
        const formData = new FormData()

        formData.set('redditiPatrimonio', JSON.stringify(this.item))

        await this.$store.dispatch('redditiPatrimonio/save', { id: this.item.id, formData })

        let item = this.$store.state.redditiPatrimonio.item
        this.item = item

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: `Operazione eseguita con successo. Il numero di protocollo del documento è: ${this.item.numeroProtocollo}`
        })
      } catch (err) {
        // this.item.stato = 'A'
        this.item.stato = 'B'
        this.$ui.showError(err)
        // back()
      }
      this.loading = false
    },

    doDeleteDraftConfirm () {
      // console.log('Prospetto redditi e patrimonio immobiliare in bozza da eliminare', this.item)

      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: 'Cancellando la bozza del prospetto redditi e patrimonio saranno eliminati tutti i dati caricati, confermi?',
        okHandler: this.doDeleteDraft
      })
    },

    async doSaveDraft () {
      try {
        this.loading = true
        // console.log('Prospetto redditi e patrimonio completo da salvare', this.item)

        // Salvataggio dei file allegati.
        const formData = new FormData()

        formData.set('redditiPatrimonio', JSON.stringify(this.item))

        await this.$store.dispatch('redditiPatrimonio/save', { id: this.item.id, formData })

        let item = this.$store.state.redditiPatrimonio.item

        // item.allegati.forEach(x => {
        //   x.uploaded = ''
        // })
        this.isModificato = false
        // console.log('isModificato', this.isModificato)
        this.item = item
        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },
    async doDeleteDraft () {
      this.loading = true
      try {
        // console.log('Prospetto redditi da eliminare!!', this.item)
        await this.$store.dispatch('redditiPatrimonio/delete', this.item)

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
        this.$router.push({ name: 'istanze' })
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },
    fieldState (field) {
      let v = this.$v.redditiPatrimonio[field]
      return v.$dirty && v.$error ? false : null
    },

    formatUcase (value, event) {
      return value.toUpperCase()
    },
    modificaFamiliare () {
      this.isModificato = true
      // console.log('modifica familiare', this.isModificato)
    }

  }
}
</script>
